<template>
  <div class="reset-card">
    <template v-if="!state.sendEmail">
      <h2 class="reset-card__title">Redefinir senha</h2>
      <p class="reset-card__sub">
        Informe seu e-mail para enviarmos uma solicitação de redefinição de senha.
      </p>

      <form @submit.prevent="handleLogin">
        <InputField
          v-model="state.email.value"
          label="E-mail"
          type="email"
          placeholder="seu@email.com"
          data-cy="email"
          :error="state.email.errorMessage"
        />

        <BaseButton type="submit" variant="primary" class="reset-card__submit" data-cy="sendEmail">
          Enviar e-mail
        </BaseButton>
      </form>

      <p class="reset-card__back">
        <router-link :to="{ name: 'Login' }">← Voltar para o login</router-link>
      </p>
    </template>

    <template v-else>
      <h2 class="reset-card__title">Verifique seu e-mail</h2>
      <p class="reset-card__sub">
        Enviamos um link de redefinição de senha para sua caixa de entrada.
      </p>

      <p v-if="!state.enabledButton" class="reset-card__timer">
        Nova solicitação disponível em {{ state.time }}s
      </p>
      <BaseButton
        variant="ghost"
        class="reset-card__submit"
        :disabled="!state.enabledButton"
        @click="handleClickResetAgain"
      >
        Tentar novamente
      </BaseButton>

      <p class="reset-card__back">
        <router-link :to="{ name: 'Home' }">Ir para o início</router-link>
      </p>
    </template>
  </div>
</template>

<script>
import { useField } from 'vee-validate';
import { reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import loginService from '../../../../api/person/login';
import BaseButton from '../../../../components/ui/BaseButton.vue';
import InputField from '../../../../components/ui/InputField.vue';
import validators from '../../../../utils/validators';

export default {
  components: {
    BaseButton,
    InputField,
  },
  name: 'ResetPasswordForm',
  props: {},
  setup(props, { emit }) {
    const router = useRouter();
    const toast = useToast();

    const TIMEOUT_TRY_AGAIN = 60;

    const { value: emailValue, errorMessage: emailErroMessage } = useField(
      'email',
      validators.validateEmptyAndEmail,
    );

    const state = reactive({
      sendEmail: false,
      time: TIMEOUT_TRY_AGAIN,
      enabledButton: false,
      email: {
        value: emailValue,
        errorMessage: emailErroMessage,
      },
    });

    const redirectLogin = () => {
      router.push({ name: 'Login' });
    };

    const resetTime = () => {
      state.time = TIMEOUT_TRY_AGAIN;

      const idInterval = setInterval(() => {
        if (state.time <= 0) {
          state.enabledButton = true;
          clearInterval(idInterval);
        } else {
          state.time -= 1;
        }
      }, 1000);
    };

    async function handleLogin() {
      const { data, errors } = await loginService.resetPassword({
        email: state.email.value,
      });

      if (errors) {
        toast.error(errors.statusText);
        return;
      }

      if (data) {
        toast.success(
          'E-mail enviado. Verifique sua caixa de e-mails e realize a redefinição de senha',
        );
        resetTime();
        state.sendEmail = true;
        state.enabledButton = false;
      }
    }

    const handleClickResetAgain = () => {
      state.email.value = '';
      state.sendEmail = false;
    };

    return {
      state,
      emit,
      handleLogin,
      redirectLogin,
      handleClickResetAgain,
    };
  },
};
</script>

<style scoped>
.reset-card {
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  gap: var(--gap-lg);
  background: var(--navy-card);
  border: 1px solid var(--navy-border);
  border-radius: var(--r-lg);
  padding: 40px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
}

.reset-card form {
  display: flex;
  flex-direction: column;
  gap: var(--gap-lg);
}

.reset-card__title {
  font-family: var(--font-brand);
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--white);
}

.reset-card__sub {
  font-family: var(--font-brand);
  font-size: 14px;
  color: var(--muted);
  margin-top: -8px;
}

.reset-card__submit {
  width: 100%;
}

.reset-card__timer {
  font-family: var(--font-brand);
  font-size: 13px;
  color: var(--faint);
  text-align: center;
}

.reset-card__back {
  text-align: center;
  font-family: var(--font-brand);
  font-size: 13px;
}

.reset-card__back a {
  color: var(--cyan);
  font-weight: 600;
  text-decoration: none;
}
</style>
